import { useState, useEffect } from 'react';
export const useValidatedField = (initialValue = '', validationConfig) => {
    const [value, setValue] = useState(initialValue);
    const [touched, setTouched] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [manualErrorMessage, setManualErrorMessage] = useState(null);
    useEffect(() => {
        // If there's a manual error message, don't override it with automatic validation
        if (manualErrorMessage !== null) {
            return;
        }
        let isValid = false;
        if (validationConfig.validateFn) {
            isValid = validationConfig.validateFn(value);
        }
        else if (validationConfig.compareValue !== undefined) {
            // For password confirmation
            isValid = value === validationConfig.compareValue && value !== '';
        }
        else if (validationConfig.regex) {
            isValid = validationConfig.regex.test(value);
        }
        setErrorMessage(isValid ? '' : validationConfig.errorMessage);
    }, [value, validationConfig, manualErrorMessage]);
    const handleChange = (newValue) => {
        setValue(newValue);
        setTouched(true);
        // Clear manual error when user starts typing
        setManualErrorMessage(null);
    };
    const handleSetErrorMessage = (message) => {
        setManualErrorMessage(message);
        setErrorMessage(message);
    };
    return {
        value,
        setValue,
        touched,
        setTouched,
        errorMessage,
        setErrorMessage: handleSetErrorMessage,
        isValid: errorMessage === '',
        handleChange,
    };
};
export default useValidatedField;
